export default {
  ViewRecord: 'View Record',
  Document: 'Document',
  QA: 'Q&A',
  WebsiteImport: 'Website Import',
  Question: 'Question  ',
  Answer: 'Answer: ',
  EnhancedSearch: 'Hybrid Search',
  selectOption: 'Please select',
  clearMemory: 'Clear memory',
  resetInput: 'Reset input',
  startRunning: 'Start run',
  running: 'Running',
  PleaseSelectTriggerTime: 'Please select trigger time',
  PleaseEnterTriggerContent: 'Please enter trigger content',
  Add: 'Add',
  Delete: 'Delete',
  PrefixMatch: 'Prefix Match',
  ContainMatch: 'Contain Match',
  SuffixMatch: 'Suffix Match',
  TriggerTime: 'Trigger Timing',
  TriggerContent: 'Trigger Content',
  TriggerMechanism: 'Trigger Mechanism',
  Colon: ': ',
  CopyApplication: 'Duplicate',
  ConfirmCopy: 'Will automatically create the same agent, confirm copy?',
  CopyConfirm: 'Confirm Copy',
  CopySuccess: 'Copy successful',
  Code: 'code:',
  CopySuccessful: 'Copy successful',
  ShareApplication: 'Share',
  ApplicationLink: 'App link ',
  StartChat: 'Start chat',
  Drawing: 'Drawing',
  createApp: 'Create agent',

  SetAIPromptToBuildBot: 'Set AI prompts to quickly build a bot',

  SupportKnowledgeBaseAndDatabase: 'Support knowledge base and database capabilities',
  AIAutoFill: 'AI auto-generate',
  AIAutoFillTip: 'After filling in the agent name and description, AI will help you generate other content. Note that for key configurations like "App Settings", it is recommended to optimize after generation for better results.',
  CopyFromTemplateCenter: 'Create from template',
  ApplicationName: 'Agent name',
  EnterInterestingName: 'Give the agent a unique name',
  ApplicationDescription: 'Agent description',
  IntroduceYourApp: 'Introduce what this agent does',
  OpeningIntroduction: 'Opening introduction',
  OpeningIntroTip: 'This is the first message sent by the agent when users first use it on the webpage. Supports Markdown format. Also supports using "[]" symbols to generate guiding questions that can be clicked to send, e.g. ',
  smartAssistantPrompt: 'I am your smart assistant, you can ask me ',
  OpeningIntroExample: '- [How to plan an activity?]',
  ApplicationAvatar: 'Agent avatar',
  AvatarCreationIdea: 'Avatar creation idea',
  IsPublic: 'Public',
  PublicTip: '(If public, it can be searched and used in the agent store)',
  SelectCategory: 'Category',
  SelectAppCategory: 'Select agent category',
  ApplicationSettings: 'Instructions',
  ApplicationSettingsTip: 'Core instructions are very important, determining the bot\'s character settings, functions and work characteristics. Please try to describe in detailed natural language, the more specific the better',
  KnowledgeBaseBinding: 'Knowledge',
  SelectKnowledgeBase: 'Add knowledge',
  View: 'View',
  UploadFile: 'Upload file',
  UnstructuredDocument: 'Text document',
  AutoParseDocument: 'Automatic parsing, user-friendly',
  QAFormat: 'Q&A Format',
  ImportQA: 'Questions and answers, more accurate',
  BindExistingKnowledgeBase: 'Bind existing knowledge',
  CreateApplication: 'Create agent',
  ApplicationCreationSuccess: 'Agent created successfully',
  IntegrateToSystem: 'You can also integrate this application into various apps',
  QuickIntegration: 'Quick Integration',
  ApplicationSettingsExample: {
    prompt: 'e.g. Please act as an interviewer and ask interview questions to candidates for the "Product Manager" position. Only ask one question at a time and wait for the candidate\'s response',
    embedding: 'e.g. Please act as LinkAI platform\'s intelligent customer service, answer user questions about LinkAI usage based on information provided in the knowledge base'
  },
  Yes: 'Yes',
  No: 'No',
  SelectCategoryPlaceholder: 'Select agent category',
  DragFileOrClickUpload: 'Drag files here or <em>click to upload</em>',
  SupportedFileFormats: 'Supports .txt, .pdf, .docx, .md. Max 10MB each. You can upload more files after creation',
  SupportCSVFile: 'Supports CSV files with UTF-8 format, click to',
  DownloadTemplate: 'download template',
  SaveAsUTF8: '',
  Cancel: 'Cancel',
  CreateApp: 'Create agent',
  ApplicationCreatedSuccessfully: 'Agent created successfully',
  GeneratedApplicationLink: 'Generated unique link for your agent',
  DebugNow: 'Debug Now',
  CopyLink: 'Copy Link',
  IntegrateToApps: 'You can also integrate the agent into various channel',
  ConversationAPI: 'Conversation API',
  WebEmbed: 'Web Integration',
  WeChat: 'WeChat',
  WeChatWork: 'WeChat Work',
  WeChatOfficialAccount: 'WeChat Official Account',
  Feishu: 'Feishu',
  WeChatService: 'WeChat Service',
  DingTalk: 'DingTalk',
  QuickAccess: 'Quick Integration',
  CopyCode: 'Copy Code',
  Confirm: 'Confirm',
  ApplicationSettingsDialog: 'Prompt',
  ImageUploadFormatError: 'Image upload only supports jpeg, png format',
  ImageSizeError: 'Image size must be less than 5MB!',
  Official: 'Official',
  PleaseUploadDocFormat: 'Please upload txt, pdf, md, docx format files',
  PleaseUploadCSVFormat: 'Please upload csv format file',
  PleaseEnterNameAndDesc: 'Please enter application name and description',
  PleaseEnterDesc: 'Please enter application description',
  DescriptionLengthTip: 'Description must be more than 5 characters',
  PleaseEnterIntro: 'Please enter opening introduction',
  IntroLengthTip: 'Opening introduction must be more than 5 characters',
  PleaseUploadAvatar: 'Please upload avatar',
  PleaseSelectCategory: 'Please select agent category',
  PleaseEnterSettings: 'Please enter app settings',
  PleaseUploadDoc: 'Please upload document',
  DefaultAvatarTip: 'Cannot use default avatar when publishing to square',
  CreatingApplication: 'Creating knowledge agent, please wait',
  FileEncodingError: 'File encoding error, please save as UTF-8 format and upload again, or contact customer service',
  TokenLimitExceeded: 'Size limit exceeded, single application token count cannot exceed 1 million, please contact customer service for additional requirements',
  CreateApplicationFailed: 'Failed to create application',
  KnowledgeBaseUpdating: 'Knowledge base updating, please wait',
  PleaseEnterAppName: 'Please enter application name!',
  PleaseEnterAppDesc: 'Please enter application description!',
  FileUploadSizeLimit15: 'File size must be less than 15MB!',
appNameAndDescription: 'Please fill in the application name and application description first.',
  AppDescLengthTip: 'Application description must be more than 5 characters~',
  AutoGenerating: 'Automatically generating, please wait',
  BasicConfiguration: 'Basic',
  RateLimit: 'Rate Limit',
  AdvancedConfiguration: 'Advanced',
  Debug: 'Preview',
  Save: 'Save',
  StandardFeature: 'Pro feature',
  VersionDescription: 'version description',
  ProFeature: 'Team feature',
  VipFeature: 'VIP feature',
  AddConfiguration: 'Add',
  NoRateLimitConfig: 'No rate limit configuration, please click the button in the upper right corner to add.',
  ByUsageFrequency: 'Rate Limit Configuration',
  ConfirmDelete: 'Confirm delete?',
  Target: 'Target ',
  Channel: ' channel, ',
  SingleUserPer: 'single user per ',
  CanOnlyReply: ', can only chat ',
  Messages: ' times.',
  ReplyWhenExceeded: 'Reply when exceeded ',
  NoReplyByDefault: 'No reply by default',

  // Time units
  Second: 'Second',
  Minute: 'Minute',
  Hour: 'Hour',
  Day: 'Day',

  // Channel options
  All: 'All',

  PersonalSubscription: 'Personal Subscription',
  EnterpriseOfficialAccount: 'Enterprise Official Account',
  WeChatWorkInternalApp: 'WeChat Work Internal App',

  // Messages
  DeleteSuccess: 'Delete successful',
  DeleteFailed: 'Delete failed',
  UnsavedConfigTip: 'You have unsaved configuration, please save first.',
  RequestFailed: 'Request failed',
  InvalidRateLimitRule: 'Please set valid rate limit rule, cannot be 0',
  SavingData: 'Saving, data processing takes time, please wait patiently~',
  SaveSuccess: 'Save successful',
  SaveFailed: 'Save failed',

  // Model selection translations
  Model: 'Model',
  SelectModel: 'Select Model',
  Plugins: 'Plugins',

  // New translations
  IntelligentTransfer: 'Transfer to manual',
  ConfigurationItem: 'Name',
  Status: 'Status',
  Operation: 'Operation',
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Configure: 'Settings',
  Humanization: 'Personification',
  PromptOptimization: 'Prompt Optimization',
  SplitReply: 'Split Reply',
  SplitReplyTip: 'Long content will be randomly split into multiple segments for reply',
  MergeReply: 'Merge Reply',
  MergeReplyTip: 'Multiple questions within a short time will be summarized and replied at once. This feature requires setting the "Delay Reply" time below to take effect',
  DelayReply: 'Delay Reply',
  DelayReplyTip: 'Additional delay before content generation and reply',
  Seconds: 'seconds',
  PleaseSelectTriggerMethod: 'Please select trigger method',
  PleaseEnterIntentKeyword: 'Please enter intent/keyword',
  SaveSuccessful: 'Save successful',
  PleaseSetDelayTime: 'Please set delay reply time for merge reply to take effect.',
  SavingInProgress: 'Saving, data processing takes time, please wait patiently~',

  // Database Setting translations
  DatabaseSettings: 'Database',
  DatabaseSettingsTip: 'If you add a database, the AI will decide whether to operate the database based on the user\'s question, the name and description of the database during the conversation, and then generate SQL statements for execution based on the description of the data table and the names and descriptions of the data fields.',
  BindDatabase: 'Add',
  AddDatabase: 'Add Database',
  NoDatabase: 'Please add database',
  CreateDatabase: 'Create database',
  RefreshDatabase: 'Refresh Database',
  BindDatabaseTip: 'You can add multiple databases, and after deselecting the added databases and saving, you can cancel.',
  BuiltInDatabase: 'Built-in',
  RemoteDatabase: 'Remote',
  ViewDetails: 'View Details',
  BindingSuccessful: 'Binding successful',
  CancelBinding: 'Cancel binding',
  ConfirmCancelBinding: 'Confirm cancel binding?',

  Empty: 'Empty',

  // Intelligent Transfer related
  ManualServiceConfiguration: 'Manual Service Config',
  TriggerConfiguration: 'Triggers',
  TriggerTimingTip: 'When the user\'s last question meets any of the following conditions, manual service can be triggered',
  TriggerMethod: 'Trigger Method',
  IntentKeyword: 'Intention/Keyword',
  KeywordMatch: 'Keyword Match',
  IntentRecognition: 'Intent Recognition',
  PleaseEnter: 'Please enter',

  // Reply Configuration
  ReplyConfiguration: 'Reply',
  DefaultReply: 'Default Reply',
  DefaultReplyTip: 'Default reply sent by AI to users after triggering manual service (only once)',
  ReplyMode: 'Reply Mode',
  ReplyModeTip: 'After switching to manual service, there are three modes to choose from ',
  ReplyModeDetail: '1. No Reply: After switching to manual service, AI will not reply to user\'s subsequent questions, need to manually switch to AI reply in "Chat Management" to continue replying\n2. Continue Reply: After switching to manual service, AI will continue to reply to user\'s subsequent questions\n3. Delayed Reply: After switching to manual service, AI will automatically switch to AI reply after the specified delay time, during which it will not reply to users',
  NoReply: 'No Reply',
  ContinueReply: 'Continue Reply',
  DelayedReply: 'Delayed Reply',
  DelayedTime: 'Delay',
  MinutesAutoSwitch: 'minutes, switch back to AI reply.',

  // Notification Configuration
  NotificationConfiguration: 'Notification',
  NotificationMethod: 'Channel',
  NotificationEmail: 'Email',
  SMSNotification: 'SMS',
  NotificationEmailTip: 'After manual service is triggered, system sends email to specified email address',
  SMSNotificationTip: 'After manual service is triggered, system sends SMS to specified space member\'s phone number bound to LinkAI account',
  WeChatMPNotification: 'WeChat',
  WeChatMPNotificationTip: 'After manual service is triggered, system sends message notification through "LinkAI Platform" official account to specified space member\'s WeChat bound to LinkAI account',
  WebhookNotification: 'Webhook',
  WebhookNotificationTip: 'After manual service is triggered, system sends notifications to internal group chats of WeCom/DingTalk/Feishu through configured Webhook bot, using summary generated based on "Summary Template" as notification content',

  // Space Members
  SpaceMembers: 'Space Members',
  ConfigureWebhook: 'Configure Webhook ',
  WebhookChannel: 'Webhook Channel ',
  PleaseConfigureWebhook: 'Please configure Webhook',

  // Summary Configuration
  IntelligentSummary: 'AI Summary',
  SummaryTemplate: 'Summary Template',
  SummaryTemplateTip: 'After manual service is triggered, AI will generate intelligent summary based on configured template and chat content with users, and display it when switching to manual service in "Chat Management", also used for notification to group chat through Webhook after manual service',
  TemplateTipDetail: 'When setting template, add content you want AI to summarize, and use natural language to describe specific meaning of that content, so AI can generate based on description.\nExample: "Content: Purchase intention; Description: If customer expresses wanting to buy xx product, then "Yes", otherwise "No""',
  Content: 'Content',
  SummaryTemplateProperty: 'Property',
  Description: 'Description',

  // AI Tagging
  AITagging: 'AI Tagging',
  AITaggingTip: 'When switching to manual service, AI will judge whether it matches the tag based on selected tag\'s description and chat content with users. If matched, automatically add that tag to user and display in "Customer Management"',
  SelectReference: 'Select reference',

  // Messages
  PleaseSelectNotifyMembers: 'Please select space members to notify',
  PleaseEnterSummaryTemplate: 'Please enter summary template',
  SaveInProgress: 'Saving, data processing takes time, please wait patiently',

  // Channel related
  DingTalkBot: 'DingTalk Bot',
  FeishuBot: 'Feishu Bot',
  WeChatWorkBot: 'WeCom Bot',
  AddWebhookDingTalk: 'Please add custom bot in DingTalk group and get Webhook URL ',
  AddWebhookFeishu: 'Please add custom bot in Feishu group and get Webhook URL ',
  AddWebhookWecom: 'Please add group bot in WeCom internal group and get Webhook URL ',
  DingTalkSecret: 'For DingTalk group bot security settings, select "Sign" and get the key ',
  FeishuSecret: 'For Feishu group bot security settings, select "Signature Verification" and get the key ',

  // Intelligent Transfer related


  IntentKeywordTip: 'When trigger method is keyword matching, set keywords, and manual service will be triggered when user\'s question contains the keywords.\nWhen trigger method is intent recognition, use natural language to describe user intent that triggers manual service, and manual service will be triggered when user\'s question semantically matches that intent.',

  // Intelligent Transfer related
  KeywordMatchOption: 'Keyword Match',
  IntentRecognitionOption: 'Intent Recognition',

  // Form placeholders
  PleaseEnterContent: 'Please enter content',

  BindKnowledgeBase: 'Add',
  BindKnowledgeBaseTip: 'You can bind multiple knowledge bases, and clicking again will unbind them',
  RefreshKnowledgeBase: 'Refresh knowledge',
  CreateKnowledgeBase: 'Create knowledge',
  EmptyKnowledgeBase: 'Empty',
  ConfirmBinding: 'Confirm Binding',
  BasicInfo: 'Profile',
  AppCode: 'Code',
  AppName: 'Name',
  DeleteApp: 'Delete',
  AppType: 'Type',
  AppAvatar: 'Icon ',
  AutoGenerate: 'Auto Generate',
  UpgradeToKnowledgeAppTip: 'Upgrade to knowledge app, upload documents and data to create exclusive AI agent',

  AppShare: 'Share',
  ExclusiveLink: 'Link',
  Public: 'Public',
  AppDescription: 'Description',
  OpeningIntro: 'Greeting',
  FirstMessagePlaceholder: 'The first message of the app. e.g. How can I help you?',
  modelSettings: 'Models',

  defaultModel: 'Default model',
  defaultModelForService: 'Default model used when providing services through application access channels.',

  OptionalModels: 'Optional models',
  OptionalModelsTip: 'Models that users can switch between during debugging and web chat',
  sound: 'Voice',

  Memory: 'Memory',
  MemoryTip: 'Number of context turns to maintain during conversation, each turn includes one question and one reply',
  SelectMemoryContextTurns: 'Select memory context turns',
  Turns: 'turns',
  RetainFor: 'retain for',
  Minutes: 'minutes',
  Temperature: 'Temperature',
  TemperatureTip: 'Higher temperature leads to more creative and uncertain replies, lower temperature leads to more rigorous replies',
  appSettingsImportance: 'Prompt are crucial as they determine the character design, functionalities, and working characteristics of the agent. Please describe in as much detail as possible using natural language; the more specific, the better the effect.',
  knowledgeBaseConfig: 'Knowledge',

  RetrievalMethod: 'Search strategy',
  SemanticSearch: 'Semantic Search',
  EnhancedRetrieval: 'Hybrid',
  SemanticSimilarityThreshold: 'Minimum matching degree',
  SingleSearchCount: 'Maximum recalls',
  SemanticSearchCount: 'Semantic recalls',
  FullTextSearchCount: 'Full-text recalls',
  NoHitStrategy: 'No replies recalled',
  FreeStyle: 'Default',
  FixedText: 'Customization',
  ManualService: 'Manual Service',
  KnowledgeBaseSource: 'Show source',
  Enableds: 'Enabled',
  Disableds: 'Disabled',
  noKnowledgeBase: 'Please add knowledge base',

  PluginConfiguration: 'Plugins',
  AddPlugin: 'Add',
  AddPluginTitle: 'Add plugin',
  CreatePlugin: 'Create custom plugin',
  ShowThinkingProcess: 'Show thinking process',
  PluginExecutionProcess: 'Plugin execution process',
  MultiRoundThinking: 'Multi-round Thinking',
  MultiRoundThinkingTip: 'Agent mode, the ability to complete tasks through multiple rounds of thinking and using plugins (beta version)',
  MaxThinkingRounds: 'Max Thinking Rounds',
  SelectMaxThinkingRounds: 'Please select max thinking rounds',
  PluginExecutionStrategy: 'Plugin Execution Strategy',
  knowledgeBasePriority: 'Knowledge Base Priority: Prioritize searching the knowledge base for user questions, and only resort to plugins if not found.',
  pluginPriority: 'Plugin priority: Prioritize decision-making plugins, only attempt to retrieve from the knowledge base if the plugin does not match.',
  executeKnowledgeBaseAndPluginsSimultaneously: 'Execute the knowledge base and plugins simultaneously: Each request will attempt to retrieve from the knowledge base and select plugins, then summarize the results of both for answering questions.',
  selectPluginExecutionPolicy: 'Please select a plugin execution policy.',
  noPluginsAvailable: 'Please add plugins',
  AddKnowledgeBase: 'Add Knowledge Base',
  bindMultipleKnowledgeBases: 'You can add multiple knowledge bases, and after deselecting the added knowledge bases and saving, you can cancel.',
  confirmation: 'Confirmation',
  searchConfiguration: 'Search',
  semanticVectorSearch: 'Search for related text using semantic vectors.',
  enhancedSearchWithSemanticVector: 'Enhanced search for related texts through full-text (keyword) retrieval combined with semantic vector retrieval.',
  semanticSimilarityThreshold: 'Only knowledge base entries with semantic similarity above the threshold will be retrieved, which can be tested in "Knowledge Base - Search Test":',
  highSemanticSimilarity: 'When the semantic similarity is high (e.g., above 0.8), only knowledge highly relevant to the question will be retrieved, making it more accurate, but it may also easily miss some entries.',
  lowSemanticSimilarity: 'When the semantic similarity is low (e.g., below 0.7), it may retrieve content with lower relevance, but the retrieval scope will be broader.',
  maxParagraphsForSingleQnA: "Maximum number of paragraphs for semantic retrieval from the knowledge base in a single Q&A, default is 3. Increasing the number will increase token consumption, be careful not to exceed the model's maximum context.",
  maxParagraphsForKeywordSearch: "Maximum number of paragraphs for full-text keyword search from the knowledge base per query, default is 1. Increasing this will increase token consumption; be careful not to exceed the model's maximum context.",
  maxSearchResults: 'The sum of the full-text search results and semantic search results must not exceed 10, with priority given to the semantic search results setting.',
  noMatchingKeywords: 'If there are no matching keywords during actual use, the enhanced full-text search results may be 0.',
  fullTextSearchHint: 'Tip: Full-text search is a supplement to semantic search, and the maximum number of the two is 10, and the number of semantic search is preferred',
  noSimilarContentStrategy: 'Strategy when no similar content is found in the knowledge base.',

  freePlay: 'Default: The AI infers and responds based on app settings.',
  fixedResponse: 'Customization: Reply according to the specified text.',
  transferToHuman: 'Manual Service: Remind human processing based on the rules in the advanced configuration - transfer to human settings of the agent.',
  TransferToHuman: 'Manual config',
  pleaseEnterCopy: 'Please enter',
  knowledgeBaseSource: 'Show sources',
  showKnowledgeBaseSource: 'After enabling, if the question matches the knowledge base content, the source file name, website name, and URL of the knowledge base content will be displayed in the response, as shown in the figure ',
  knowledgeBaseCitationDisplayThreshold: 'Minimum matching degree',
  knowledgeBaseSearchResults: 'The knowledge base search results typically contain multiple entries, and the model usually references the knowledge base content that is more relevant to the question when generating a response, rather than all search results.',
  setThreshold: 'After setting this threshold, only the retrieval results that meet the similarity requirement will be displayed when showing the sources of the knowledge base. It needs to be set to be greater than or equal to the "semantic similarity threshold" in the "retrieval configuration."',
  confirmConfiguration: 'Confirm Configuration',
  modelSelection: 'Model Selection',
  selectModel: 'Please select a model.',
  generalLargeModel: 'General Large Model',
  industryLargeModel: 'Industry Large Model',
  maxContext: 'Maximum Context',
  ShowcasingThoughtprocess: 'Showcasing the thought process',
  confirmConfigurationModel: 'Confirm Configuration Model',
  customPlugin: 'Custom Plugins',
  added: 'Added',
  builtInPlugin: 'Built-in Plugins',
  confirmAdd: 'Confirm Add',

  // 已有的翻译...
  Descriptions: 'Description ',
  Introductions: 'Introduction ',
  Prices: 'Price',
  PointsPerTime: ' credits / time',
  PointsPerThousandTokens: ' credits/thousand tokens',
  PriceDetails: 'Price Details',
  ViewPriceDoc: 'View Price Doc',
  ConfigureKey: 'Configure Key',
  Creator: 'Creator',
  ConfirmConfiguration: 'Confirm Configuration',
  firstSentenceOfApp: 'The first sentence of the app. e.g. How can I assist you?',
  oneClickOptimize: 'One-click optimization',
  optimizationInProgress: 'Optimization in progress.',
  optimizationCompleted: 'Optimization Completed',
  stopOutput: 'Stop',
  prompt: 'Prompt:',
  bindKnowledgeBase: 'You can bind your knowledge base here, allowing the application to provide personalized intelligent Q&A based on the uploaded knowledge content.',
  maximized: 'Maximized',
  pluginPrioritys: 'Plugin Priority',
  knowledgeBasePrioritys: 'Knowledge Base Priority',
  knowledgeBaseAndPluginsExecution: 'Knowledge Base and Plugins Executing Simultaneously',
  imageUploadSupportedFormats: 'Image upload only supports jpeg and png formats.',
  imageSizeLimit: 'Image size must be less than 5MB!',
  confirmUpgradeToKnowledgeApplication: 'Are you sure you want to upgrade to Knowledge Application?',
  upgradeApp: 'Upgrade Application',
  confirmUpgrade: 'Confirm Upgrade',
  upgradeSuccess: 'Upgrade successful.',
  playbackFailedContactAdmin: 'Playback failed, please contact the administrator.',
  appDeletionWarning: 'Once the agent is deleted, the data cannot be recovered. Are you sure you want to delete it?',
  deleteApp: 'Delete',
  confirmDeletion: 'Confirm deletion',
  deleteSuccess: 'Delete successful',
  pleaseEnterAppDescription: 'Please enter the application description!',
  appDescriptionTooShort: 'The application description must be longer than 5 characters~',
  pleaseEnterAppIntroduction: 'Please enter the application introduction!',
  appIntroductionTooShort: 'The application introduction must be longer than 5 characters~',
  pleaseUploadImage: 'Please upload an image!',
  pleaseAddModel: 'Please add a model!',
  pleaseSelectDefaultModel: 'Please select a default model!',
  defaultAvatarWarning: 'You cannot use the default avatar when publishing to the square~',
  appSavingMessage: 'Saving, it will take some time, please be patient.',
  saveSuccessMessage: 'Save successful',
  saveFailureMessage: 'Failed to modify the application',
  knowledgeBaseBound: 'The current knowledge base is bound.',
  bindingKnowledgeApplication: 'Binding knowledge application, please wait a moment~',
  knowledgeBaseUpdating: 'Knowledge base is being updated, please wait~',
  configurationSuccess: 'Configuration successful.',
  enableHumanTransferInAdvancedSettings: 'Please enable manual configuration in the advanced settings first.',
  linkAIIntelligentCustomerService: 'e.g. Please act as the intelligent customer service of the LinkAI platform, answering user questions about using LinkAI based on the information provided in the knowledge base.',
  interviewQuestionForProductManager: "e.g. Please act as an interviewer and ask a question related to the 'Product Manager' position to the candidate, asking one question at a time and waiting for the candidate's response.",
  modelRetrievalLengthCannotBeZero: 'The model retrieval length cannot be zero.',
  closeSuccess: 'Close successful.',
  selectPlugin: 'Please select a plugin.',
  doNotAddPluginsAgain: 'Please do not add plugins again.',
  successfullyEnabled: 'Successfully enabled.',
  addSuccess: 'Addition successful.',
  confirmDeletePlugin: 'Are you sure you want to delete this plugin?',
  removePlugin: 'Remove Plugin',
  generationFailed: 'Generation failed!',
  CannotBeEmpty: ' cannot be empty',
  viewDetails: 'Details',
  deleteChatHistoryConfirmation: "Deleting will clear this role's chat history. Do you confirm deletion?",
  deleteChat: 'Delete chat',
  stopRunning: 'Stop',
  runYourCreativity: 'Start your creativity ~',
  taskSubmitting: 'Task is being submitted, please wait',
  stopConversation: 'Stop',
  makeSameStyle: 'Make the same type',
  host: 'Host',
}